module.exports = __webpack_public_path__ + "img/trx.82ae52c4.svg";